import { requestTypes } from '../constants'

export const initialValues = {
  ClientType: 1,
  action: requestTypes.add,
  Open_Day: '',

  // basic personal information default values (checked)
  IND_Name: '',
  IND_Surname: '',
  IND_FatherName: '',
  IND_DOB: '',
  IND_BirthCountryID: 1,
  IND_BirthPlace: 'მიუთითებელია',

  // business information default values (checked)
  ORG_IndustryID: 7,
  ORG_IndustrySubDetailID: 1, // todo:  change value once confirmed
  ORG_IndustrySubID: 1, // Previous value was 15
  BusinessTypeID: '',
  IND_RegisteredBusinessID: 1,
  IND_StaticBusinessID: 1,
  LicenseCardNumber: '',
  CountryID: '',
  Country2ID: '',
  CountryBusID: '',

  // identity information default values (checked)
  IDCardTypeID: 1,
  IDCardIssuerID: 1,
  CardNumber: '',
  OtherIDNumber: '',
  CardNumberAlt: '',
  OtherIDNumberAlt: '',
  IDCardRegDate: '',
  IDValidityDate: '',
  IND_Sex: 1,
  Comment: '',

  // address information default values (checked)
  Address: '',
  CityID: 2,
  Address2: '',
  City2ID: 2,

  // business contact information default values (checked)
  AddressBus: '',
  ZoneBusID: 1,
  DistrictBusID: 1,
  CityBusID: 2,
  Phone: '',
  CellPhone: '',
  Email: '',
  Email1: '',
  CellPhoneValidateCode: '',

  // family information default values (checked)
  IND_FamilyMembers_Total: 0,
  FemaleFamily: 0,
  InvalidFamily: 0,
  IND_FamilyMembers_Bus: 0,
  IND_Children: 0,
  OldFamily: 0,
  IND_Dependants: 0,
  IND_Dependants_Female: 0,
  IND_Dependants_IDP_Total: 0,
  IND_Employed_Total: 0,
  IND_Employed_Female: 0,
  IND_Employed_IDP_Total: 0,

  // client references default values (checked)
  ReferralID: 1,
  ReferralNote: '',

  // selects default values (checked)
  IND_MaritalStatusID: 1,
  IND_JobStatusID: 1,
  IND_EducationID: 1,
  IND_JobPositionID: 1,
  IND_ProfessionID: '',
  IND_IDP: 1,
  IND_IncomeID: 1,
  IND_Resident: 1,
  IND_ExpencesID: 1,
  IND_NationalityID: 1,
  IND_DwellingID: 1,
  CitizenshipID: 2490,
  Citizenship2ID: 2490,
  IND_Insider: 1,
  IND_LanguagesID: 1,
  IND_LandID: 1,
  IND_HealthID: 1,
  ReligionID: 1,
  IND_EnglishKnowledge: 1,
  RaceID: 1,
  IND_ReadingSkills: 1,
  CasteID: 1,
  SMSPrefID: 1,
  EmailPrefID: 1,
  MCLEnabled: 1,
  SDAEnabled: 1,
  KYCValidityID: 1,
  StatusLevelID: 1,
  PEPFlag: 1,
  AMLStatusID: 1,
  AMLIndustryID: 1,
  AMLSuspiciousID: 1,
  AutoCoverPrefID: 1,
  ClientNotClientFlag: 1,
  SpecialNeedsFlag: 1,
  SMSSignFlag: 1,

  // additional fields default values (checked)
  CField1: '',
  CField2: '',
  CField3: '',
  CField4: '',

  // english fields default values (checked)
  IND_Name_ALT: '',
  IND_Surname_ALT: '',
  IND_FatherName_ALT: '',
  IND_BirthPlace_ALT: 'Miutitebelia',
  Address_ALT: '',
  Address2_ALT: '',
  AddressBus_ALT: '',
}

export const dateFields = ['IND_DOB', 'IDCardRegDate', 'IDValidityDate']

export const SECTIONS = 6
